import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ImageLocation, SenseImageLocation } from 'src/utils/URLUtils';
import styles from './LoadPage.module.scss';

const LoadPage = () => {
    const { t } = useTranslation();
    const cityImages = [
        '7d7c3ca6-c0e6-4a3f-871a-701490fd1c53',
        '8c1d1b75-c84e-4e03-8c52-1b9fc680bf23',
        '3f9609e2-9614-40fa-927e-5d8c2aa0f9f5',
        '971220b8-8bdc-4c19-b202-af0ed103b753'
    ];

    const [randomCity] = useState(() =>
        cityImages[Math.floor(Math.random() * cityImages.length)]
    );

    // Add state to track which rectangles are active
    const [activeRectangles, setActiveRectangles] = useState(0);
    const [loadedImages, setLoadedImages] = useState<{ [key: string]: boolean }>({});

    // Add effect to animate rectangles
    useEffect(() => {
        const interval = setInterval(() => {
            setActiveRectangles(prev => (prev + 1) % 15); // 15 to complete the cycle
        }, 200); // Adjust timing as needed

        return () => clearInterval(interval);
    }, []);

    const handleImageLoad = (imageKey: string) => {
        setLoadedImages(prev => ({ ...prev, [imageKey]: true }));
    };

    return (
        <div className={styles.loadPage}>
            <img
                src={ImageLocation('onboarding/Loading-Logo.png')}
                alt={t('logo')}
                className={`${styles.logo} ${loadedImages['logo'] ? styles.loaded : ''}`}
                loading="eager"
                onLoad={() => handleImageLoad('logo')}
            />

            <img
                src={SenseImageLocation(randomCity)}
                alt={t('word')}
                className={`${styles.word} ${loadedImages['word'] ? styles.loaded : ''}`}
                loading="eager"
                onLoad={() => handleImageLoad('word')}
            />

            <div className={styles.loadingSection}>
                <p className={styles.loadingText}>{t('Loading Your Progress')}</p>
                <div className={styles.progressBar}>
                    {[...Array(14)].map((_, index) => (
                        <div
                            key={index}
                            className={`${styles.rectangle} ${index < activeRectangles ? styles.active : ''}`}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default LoadPage;
